import React from "react";
import moment from 'moment';
import styles from './LocationTime.module.scss'

export interface ILocationTimeProps {
  timeOfTakeOff: number;
  timeOfLanding: number;
  flip?: boolean;

  className?: string;

}

const LocationTime = (props: ILocationTimeProps) => (
  <small
    className={`${styles.locationTime} ${props.className}`.trim()}
  >{moment(props.flip ? props.timeOfTakeOff : props.timeOfLanding).format('HH:mm')}</small>
);

LocationTime.defaultProps = {
  className: ''
};

export default LocationTime;
